export const itemPerPagecompanies = 100;
export const defaultPaginationResponse = {
  current_page: 1,
  data: [],
  items_per_page: itemPerPagecompanies,
  last_page: 1,
  total_items: 0
};
